module.exports = __webpack_public_path__ + "static/dark_logo_transparent-0898dba28e70d4be297eb06ae44a3659.png";